import { Borrow } from './actions/borrow';
import { Deposit } from './actions/deposit';
import { Repay } from './actions/repay';
import { SwapBorrowRateMode } from './actions/swapBorrowRateMode';
import { Withdraw } from './actions/withdraw';
import { GetAssetPrice } from './getters/GetAssetPrice';
import { GetAssetReserveData } from './getters/getAssetReserveData';
import { GetReserveConfigurationData } from './getters/getReserveConfigurationData';
import { GetReserveData } from './getters/getReserveData';
import { GetReserveTokensAddresses } from './getters/GetReserveTokensAddresses';
import { GetUserAccountData } from './getters/getUserAccountData';
import { GetUserReserveData } from './getters/getUserReserveData';
import { ApyBetween } from './validators/apyBetween';
import { ApyGreaterThan } from './validators/apyGreaterThan';
import { ApyLessThan } from './validators/apyLessThan';
var actions = {
    Borrow: Borrow,
    Deposit: Deposit,
    Repay: Repay,
    Withdraw: Withdraw,
    SwapBorrowRateMode: SwapBorrowRateMode,
};
var getters = {
    GetUserAccountData: GetUserAccountData,
    GetReserveData: GetReserveData,
    GetUserReserveData: GetUserReserveData,
    GetReserveConfigurationData: GetReserveConfigurationData,
    GetAssetReserveData: GetAssetReserveData,
    GetReserveTokensAddresses: GetReserveTokensAddresses,
    GetAssetPrice: GetAssetPrice,
    ApyLessThan: ApyLessThan,
    ApyBetween: ApyBetween,
    ApyGreaterThan: ApyGreaterThan,
};
var AaveV2 = {
    actions: actions,
    getters: getters,
};
export { AaveV2 };
